function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Path_705",
  x: 0,
  y: 0,
  width: 64,
  height: 63,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 0, 0)",
  filter: "url(#Path_705)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_705-2",
  "data-name": "Path 705",
  d: "M1427.341,507.112a2.2,2.2,0,0,1-2.195-2.188v-.044a2.2,2.2,0,0,1,2.195-2.188h16.414a2.2,2.2,0,0,1,2.195,2.188v.044a2.2,2.2,0,0,1-2.195,2.188Zm41.61,29.815a2.2,2.2,0,0,0,2.195-2.188V534.7a2.2,2.2,0,0,0-2.195-2.189h-16.413a2.2,2.2,0,0,0-2.2,2.189v.043a2.2,2.2,0,0,0,2.2,2.188Zm-20.8-27.313h-.089a2.2,2.2,0,0,0-2.195,2.189V528.38a2.2,2.2,0,0,0,2.195,2.188h.089a2.2,2.2,0,0,0,2.194-2.188V511.8a2.2,2.2,0,0,0-2.194-2.189m4.176,17.087a3.433,3.433,0,0,1,2.153,3.18v.65h12.747v-3.054a13.76,13.76,0,0,0-13.781-13.74h-1.119Zm2.153,15.89h12.748V538.9h-12.748Zm-13.092-45h-12.747v3.125h12.747Zm2.5,16a3.426,3.426,0,0,1-2.5-3.287v-1.213h-12.747v3.618a13.76,13.76,0,0,0,13.781,13.74h1.463Z",
  transform: "translate(-1416.15 -491.59)",
  fill: "#a7a8a9"
}));

function SvgIrrigationStyleNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrrigationStyleNew);
export default __webpack_public_path__ + "static/media/irrigation-style-new.ac0d6125.svg";
export { ForwardRef as ReactComponent };